import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['altImage', 'mainImage'];
  static requiredTargets = [];
  // TARGETS
  declare altImageTarget: HTMLImageElement;
  declare mainImageTarget: HTMLImageElement;
  declare readonly hasAltImageTarget: boolean;
  declare readonly hasMainImageTarget: boolean;

  initialize() {
    this.altImageError = this.altImageError.bind(this);
    this.mainImageError = this.mainImageError.bind(this);
  }

  altImageError() {
    if (this.hasAltImageTarget) {
      const classes = this.mainImageTarget.className.split(' ').filter((c) => !c.includes('hover'));
      this.mainImageTarget.className = classes.join(' ').trim();
      this.altImageTarget.remove();
    }
  }

  mainImageError() {
    if (this.hasMainImageTarget) {
      const div = document.createElement('div');
      div.classList.add('aspect-square');

      if (this.hasAltImageTarget) {
        this.altImageTarget.remove();
      }
      this.mainImageTarget.replaceWith(div);
    }
  }
}
